<template>
  <div>
    <div>
      <section class="contactPage innerPage">
        <div class="container"></div>
        <div class="container">
          <div class="breadcrumbWrap">
            <div class="breadcrumb">
              <!-- Breadcrumb NavXT 6.2.0 -->
              <span property="itemListElement" typeof="ListItem">
                <a
                  property="item"
                  typeof="WebPage"
                  title="Go to Jasper Morris Inside Burgundy."
                  href="#/"
                  class="home"
                >
                  <span property="name">首页</span>
                </a>
                <meta property="position" content="1">
              </span> /
              <span property="itemListElement" typeof="ListItem">
                <span property="name">登录</span>
                <meta property="position" content="2">
              </span>
            </div>
          </div>
        </div>
        <div class="container loginWrapper">
          <div class="loginregisterWrapper">
            <div class="loginsection" style="margin:50px auto">
              <div id="wppb-login-wrap" class="wppb-user-forms" style="line-height: 33px;">
                <div class="Login-selection">
                  <div class="Login-selection-a" style="border-bottom: 3px solid rgb(153, 0, 51)">账号密码</div>
                  <div class="Login-selection-b">手机验证码</div>
                </div>
                <form name="loginform" id="loginform" action method="post">
                  <p class="login-username">
                    <label for="user_login">账号</label>
                    <input
                      type="text"
                      name="log"
                      id="user_login"
                      size="20"
                      v-model="submitData.username"
                      placeholder="手机号码/邮箱"
                      class="input"
                    >
                  </p>
                  <p class="login-password">
                    <label for="user_pass">密码</label>
                    <input
                      type="password"
                      name="pwd"
                      id="user_pass"
                      v-model="submitData.password"
                      placeholder="密码"
                      size="20"
                      class="input"
                    >
                  </p>

                  <p class="login-dianhua" style="display:none">
                    <label for="mobile">手机号码</label>
                    <input
                      class="text-input default_field_lastname"
                      name="mobile"
                      maxlength="70"
                      v-model.number="submitData.mobile"
                      type="text"
                      id="mobile"
                    >
                  </p>
                  <p class="login-yzm" style="display:none">
                    <label for="vcode">
                      验证码
                    </label>
                    <input
                      class="text-input default_field_username"
                      name="vcode"
                      maxlength="70"
                      type="text"
                      id="vcode"
                      v-model="submitData.vcode"
                      required
                    >
                  </p>



                  <div class="container dlyzm" style="display:none">
                    <div
                      style="text-align: center; width: 480px; margin-left: 95px; display: flex; margin-top: -7px;
    margin-bottom: 20px;"
                    >
                      <button
                      @click="getcode"
                        type="button"
                        style="border: 1px; margin: 10px auto; width: 100px; text-align: center; height: 42px; background: rgb(151, 6, 53); border-radius: 8px; color: rgb(255, 255, 255); font-size: 16px; cursor: pointer;"
                      >发送验证码</button>
                      <span
                        style="color: rgb(153, 153, 153); width: 200px; display: inline-block; margin-right: 163px;"
                      >我们将向您填写的手机号码发送验证短信，请注意查收</span>
                    </div>
                  </div>


                  <p class="login-submit">
                    <input
                      type="submit"
                      name="wp-submit"
                      id="wppb-submit"
                      @click="Login"
                      value="登录"
                      class="button button-primary"
                    >
                  </p>

                  <p class="login-submit-vcode" style="display:none">
                    <input
                      type="submit"
                      name="wppb-submit-vcode"
                      id="wppb-submit-vcode"
                      @click="LoginVCode"
                      value="登录"
                      class="button button-primary"
                    >
                  </p>
                  <div class="wangji" style="text-align:center;margin-top:6px">
                  <a href="#/Forgetpassword">忘记密码?</a>
                  </div>
                </form>
              </div>
            </div>
            <div class="NotRegister" style="margin: 50px auto;
    height: 250px;line-height:33px">
              <div style="    height: 287px;">
                <h2>没有注册?</h2>
                <p>单击下面的按钮，注册成为成员，与JMIB其他成员互动。</p>
                <p>
                  <a class="button button-primary" href="#/Register">注册</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import ajax from "../ajax";

export default {

  data() {
    return {
      submitData: {
        username: "",
        password: "",
        encryption: "",
        mobile: "",
        vcode: ""
      }
    };
  },
  created() {},
  methods: {
     getcode() {
       let mobile = this.submitData.mobile;
       if (mobile) {
         ajax
           .postSendCode({ mobile, usage: "login" })
           .then(res => {
             if (res.success) {
               this.submitData.encryption = res.data;
               alert("验证码发送成功，请注意查收！");
             } else {
               alert(res.message);
             }
           });
       } else {
         alert("请正确填写手机号码！");
         $("#mobile").focus();
       }
     },

    Login(e) {
      e.preventDefault();
        if (!this.submitData.username) return alert("请输入帐号！");
        if (!this.submitData.password) return alert("请输入密码！");
        ajax.postLogin(this.submitData).then(res => {
          if (res.success) {
            this.$store.commit("setuserdata", res.data);
            this.$store.commit("setUsername", res.data.nickname);
            this.$store.commit("setLogin");
            this.$router.push('/home')
          } else {
            alert(res.message);
          }
        });
    },

    LoginVCode(e) {
      e.preventDefault();
        if (!this.submitData.mobile) return alert("请输入手机号码！");
        if (!this.submitData.vcode) return alert("请输入验证码！");
        ajax.postVCodeLogin(this.submitData).then(res => {
          if (res.success) {
            this.$store.commit("setuserdata", res.data);
            this.$store.commit("setUsername", res.data.nickname);
            this.$store.commit("setLogin");
            this.$router.push('/home')
          } else {
            alert(res.message);
          }
        });
    }
  },

  mounted() {
    // setTimeout(()=>{
    //   this.$store.commit('setLogin');
    //   this.$store.commit('setUsername','王选择')
    // },2000)
    $(function() {
  $(".Login-selection-a").click(function() {
    $(this).css("border-bottom", "3px solid #990033");
    $(".Login-selection-b").css("border-bottom", "0px solid #990033");
    $(".login-username").css("display","block");
    $(".login-password").css("display","block");
    $(".login-yzm").css("display","none");
    $(".login-dianhua").css("display","none");
    $(".login-submit").css("display","block");
    $(".login-submit-vcode").css("display","none");
    $(".dlyzm").css("display","none");
    $(".wangji").css("display","block");
  });

  $(".Login-selection-b").click(function() {
    $(this).css("border-bottom", "3px solid #990033");
    $(".Login-selection-a").css("border-bottom", "0px solid #990033");
    $(".login-username").css("display","none");
    $(".login-password").css("display","none");
    $(".login-yzm").css("display","block");
    $(".login-dianhua").css("display","block");
    $(".login-submit").css("display","none");
    $(".login-submit-vcode").css("display","block");
    $(".dlyzm").css("display","block");
    $(".wangji").css("display","none");
  });
});
  }
};

</script>



// WEBPACK FOOTER //
// src/components/Login.vue